// Sales-side CHAT notification inbox.
//
// Deliberately separate from the retailer notification APIs
// (`redux/apis/retailer/notificationsApis.ts`) — that system is untouched and
// keeps serving the retailer bell. These endpoints only serve sales users.
//
// Delivery is socket-only (`sales:notification`) — there is no FCM/device token.
import axiosInstance from "../../../config/axios";

export interface SalesNotification {
  id: number;
  webUserId: number;
  type: "delivery_misconduct" | "order_issue" | "chat_message" | "chat_transfer";
  title: string;
  description: string;
  metadata: {
    // Present on every type that has a thread behind it (chat_message, order_issue,
    // chat_transfer) — this is what lets the bell deep-link into the conversation.
    // 'delivery_misconduct' deliberately creates no conversation, so it has none.
    conversationId?: number;
    customerNumber?: number;
    customerName?: string;
    orderNumber?: number | null;
    issueType?: string;
    transferredBy?: number;
  } | null;
  isRead: boolean;
  isActive: boolean;
  createdAt: string;
}

export const getSalesNotifications = async (): Promise<SalesNotification[]> => {
  const res: any = await axiosInstance.get("/sales/notifications");
  return res?.data?.data ?? [];
};

export const getSalesNotificationUnreadCount = async (): Promise<number> => {
  const res: any = await axiosInstance.get("/sales/notifications/unread-count");
  return Number(res?.data?.data?.unreadCount) || 0;
};

export const markSalesNotificationRead = async (id: number) => {
  return axiosInstance.put(`/sales/notifications/${id}/read`);
};

export const markAllSalesNotificationsRead = async () => {
  return axiosInstance.put("/sales/notifications/read-all");
};

export const deleteSalesNotification = async (id: number) => {
  return axiosInstance.delete(`/sales/notifications/${id}`);
};
